import script from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItem.vue?vue&type=style&index=0&id=6ed3fc42&lang=scss"

const __exports__ = script;

export default __exports__